import React from "react";

export default class BannerPromotion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showBanner: false,
    };
  }

  componentDidMount() {
    
    if (localStorage.getItem("seenBanner") !== "1") {
      this.setState({ showBanner: true });
      setTimeout(() => {
        // const greetBanner = document.querySelector(".greet-banner");
        // if (greetBanner) {
          localStorage.setItem("seenBanner", "1");
          this.setState({ showBanner: false }); 
        // }
      }, 15000);
    }
  }

  handleHideBanner = () => {
    this.setState({ showBanner: false }); 
  };

  render() {
    const { showBanner } = this.state;
    return (
      <>
      {showBanner && (
        <div className="greet-banner">
        <button className="close" onClick={this.handleHideBanner}>
          X
        </button>
          <div class="feliz">Happy new year</div>
          <div class="ano_novo">
            <span>202</span>
            <span class="seis">3</span>
            <span class="sete">4</span>
            <div class="balao"></div>
          </div>
          <div class="fogos">
            <div class="f1">
              <span>
                <i></i>
              </span>
              <span>
                <i></i>
              </span>
              <span>
                <i></i>
              </span>
            </div>
            <div class="f2">
              <span>
                <i></i>
              </span>
              <span>
                <i></i>
              </span>
              <span>
                <i></i>
              </span>
            </div>
            <div class="f3">
              <span>
                <i></i>
              </span>
              <span>
                <i></i>
              </span>
              <span>
                <i></i>
              </span>
            </div>
            <div class="f4">
              <span>
                <i></i>
              </span>
              <span>
                <i></i>
              </span>
              <span>
                <i></i>
              </span>
            </div>
          </div>
        </div>
      )}
      </>
    );
  }
}
